module.exports = __webpack_public_path__ + "img/VL_15_01.b834e2a1.png";